<template>
    <list-container :columns="columns" :data="items" :actions="actions" titleKey="name"
        @loadMore="$emit('loadMore')">
        <template #col-prov_aguinaldo="{ row }">
                <strong>{{ formatCurrency(row.amount == null ? row.prov_aguinaldo : row.amount) }}</strong>
        </template>
        <template #col-status_file="{ row }">
            <strong :class="row.status_file == '1' ? 'custom-success' : 'custom-danger'">
                {{ row.status_file == '1' ? 'Archivo Cargado' : 'Archivo Requerido' }}
            </strong>
        </template>
    </list-container>
</template>

<script>

import ListContainer from '@/views/app/components/containers/ListContainer.vue';
import { formatCurrency } from '@/utils/helpers'

export default {
    components: { ListContainer },
    props: {
        items: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            columns: [
                { key: 'name', label: 'client' },
                { key: 'week', label: 'week' },
                { key: 'prov_aguinaldo', label: 'Prov. Aguinaldo' },
                { key: 'status_file', label: 'status' }
            ],
            actions: [
                { tooltip: 'edit', icon: 'EditIcon', customClass: 'custom-warning', permissions:['IU BONUS EDIT'],onClick: row => this.$emit('edit',row) },
                { tooltip: 'file', icon: 'FileTextIcon', customClass:'custom-primary', permissions:['IU BONUS VIEW'], hideIf: row => row.status_file == '0', onClick: row => this.$emit('openFile',row) },
                { tooltip: 'download', icon: 'DownloadIcon', customClass: 'custom-success',permissions:['IU BONUS VIEW'],hideIf: row => row.status_file == '0', onClick: row => this.$emit('downloadFile',row) }
            ],
        }
    },
    methods: {
        formatCurrency,
        download() {

        },

    }
}
</script>

<style></style>